import { render, staticRenderFns } from "./AxCheckBox.vue?vue&type=template&id=77878efb&scoped=true"
import script from "./AxCheckBox.vue?vue&type=script&lang=ts"
export * from "./AxCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./AxCheckBox.vue?vue&type=style&index=0&id=77878efb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77878efb",
  null
  
)

export default component.exports